"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurnNftRewardBodyToJSON = exports.BurnNftRewardBodyFromJSONTyped = exports.BurnNftRewardBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function BurnNftRewardBodyFromJSON(json) {
    return BurnNftRewardBodyFromJSONTyped(json, false);
}
exports.BurnNftRewardBodyFromJSON = BurnNftRewardBodyFromJSON;
function BurnNftRewardBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transactionHash': !(0, runtime_1.exists)(json, 'transactionHash') ? undefined : json['transactionHash'],
    };
}
exports.BurnNftRewardBodyFromJSONTyped = BurnNftRewardBodyFromJSONTyped;
function BurnNftRewardBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transactionHash': value.transactionHash,
    };
}
exports.BurnNftRewardBodyToJSON = BurnNftRewardBodyToJSON;
